import { io } from 'socket.io-client'
import config from '../config/config'


export const UPDATE_THROTTLE_MS = 500


const LOGS_ENABLED = config.webpackMode !== 'production'
export const socketLog = (...args) => { if (LOGS_ENABLED) console.log(...args) }

export const createSocketConnection = (label) => {
  const token = localStorage.getItem('token')
  if (!token) {
    console.error(`[socket:${label}] no auth token — not connecting`);
    return null;
  }
  socketLog(`[socket:${label}] connecting to`, config.socketUrl)

  const socket = io(config.socketUrl, {
    auth: { token },
    transports: ['websocket'],
  })

  socket.on('connect', () => socketLog(`[socket:${label}] connected`, socket.id))
  socket.on('disconnect', (reason) => socketLog(`[socket:${label}] disconnected —`, reason))
  socket.on('connect_error', (err) => console.error(`[socket:${label}] connect_error —`, err.message))

  return socket
}
